@if (!initialized) {
    <!-- no content while loading, avoid potential flicker -->
} @else if (!isAdmin) {
    <p>{{ "set_int_no_admin_error_message" | translate }}</p>
} @else if (integration(); as i) {
    <div class="mt-4">
        @let isExternal = !integration().integration;
        @let active = i.integration?.status === "active";
        @let needsReauth = active && i.integration?.authStatus === "invalid";
        @let isRateLimited = active && i.integration?.authStatus === "rate-limited";
        @let avaiable = i.integration?.status === "available";
        @let statusReauthClass = i.devStatus && needsReauth ? "state-reauth-shift" : "";

        <div>
            <a routerLink="/settings/integrations" class="cursor-pointer text-zinc-500">
                <i class="pi pi-chevron-left text-xs"></i>
                {{ "set_int_integrations_back" | translate }}
            </a>
        </div>
        <div class="details-head relative">
            @if (i.devStatus === "alpha") {
                <span class="integration-state alpha-state {{ statusReauthClass }}" pTooltip="{{ 'set_int_alpha_tooltip' | translate }}">ALPHA</span>
            } @else if (i.devStatus === "beta") {
                <span class="integration-state beta-state {{ statusReauthClass }}" pTooltip="{{ 'set_int_beta_tooltip' | translate }}">BETA</span>
            } @else if (i.devStatus === "new") {
                <span class="integration-state new-state {{ statusReauthClass }}">{{ "set_int_card_badge_new" | translate }}</span>
            }
            <div class="w-full flex flex-row gap-4">
                <img [src]="`/assets/images/integrations/logos/${i.serviceId}.webp`" [alt]="i.name + ' logo'" class="logo" />
                <div>
                    <div class="flex flex-row items-center gap-2 mb-2 mt-1">
                        <h2 class="tb-h5 m-0">{{ i.name }}</h2>
                        @if (needsReauth) {
                            <span class="active-state reauth" pTooltip="{{ 'set_int_reauth_tooltip' | translate }}"></span>
                        } @else if (isRateLimited) {
                            <span class="active-state rate-limited" pTooltip="{{ 'set_int_rate_limited_tooltip' | translate }}"></span>
                        } @else if (active) {
                            <span class="active-state active" pTooltip="{{ 'set_int_active_tooltip' | translate }}"></span>
                        }
                    </div>
                    <div class="description">
                        {{ `${i18nPrefix}.card_description` | translate }}
                    </div>
                </div>
            </div>
            @if (needsReauth) {
                <div class="absolute right-0 top-0 max-md:static h-8">
                    <p-tag
                        class="h-8"
                        [value]="'set_int_needs_reauth' | translate"
                        [style]="{ fontSize: '0.9rem' }"
                        icon="pi pi-exclamation-triangle"
                        severity="warn"
                    >
                    </p-tag>
                </div>
            }
        </div>

        <p-card class="relative w-full">
            <div class="relative p-2">
                <div class="mb-12 grid grid-cols-[max-content_max-content] gap-12 max-md:grid-cols-1 max-md:gap-5">
                    <div class="flex flex-col gap-1">
                        <span class="text-sm opacity-70">{{ "set_int_built_by" | translate }}</span>
                        <span class="inline-flex items-center gap-2">
                            <i class="pi pi-envelope"></i>
                            {{ i.vendor }}
                        </span>
                    </div>

                    <div class="flex flex-col gap-1">
                        <span class="text-sm opacity-70">Docs</span>

                        <a class="inline-flex items-center gap-2 cursor-pointer" (click)="openDoc()">
                            <i class="pi pi-book"></i>
                            {{ "set_int_doc_button_label" | translate }}
                        </a>
                        <!--
                        TODO decide if a or p-button is better here
                        <p-button
                            class="ml-[-10px]"
                            text
                            [label]="'set_int_doc_button_label' | translate"
                            icon="pi pi-book"
                            (click)="openDoc()"
                        />
                        -->
                    </div>
                </div>

                @if (isExternal) {
                    @let extDesc = i18nPrefix + ".extended_description" | translate;
                    @let hasExtDesc = extDesc !== i18nPrefix + ".extended_description";

                    @if (hasExtDesc) {
                        <p class="mb-8">{{ extDesc }}</p>
                    }
                    @if (i.link) {
                        <button type="button" pButton (click)="openInNewTab(i.link)">
                            Learn more
                            <i class="pi pi-external-link"></i>
                        </button>
                    }
                }

                @if (avaiable) {
                    <p-button
                        data-testid="integration-connect"
                        [pTooltip]="isPro ? undefined : ('integrations_pro_only_tooltip' | translate)"
                        [tooltipDisabled]="isPro"
                        [tooltipPosition]="'top'"
                        [disabled]="!isPro"
                        [label]="'set_int_connect_label' | translate"
                        severity="primary"
                        class="absolute right-0 top-0 max-md:static max-md:mb-6 inline-block"
                        (click)="connect()"
                    />
                }

                @if (active) {
                    <div class="absolute right-0 top-0 max-md:static max-md:mb-6 flex flex-row gap-2">
                        @if (needsReauth) {
                            <p-button [label]="'set_int_reauth_label' | translate" outlined icon="pi pi-refresh" severity="warn" class="" (click)="reauth()" />
                        }
                        <p-button
                            data-testid="integration-disconnect"
                            [label]="'set_int_disconnect_label' | translate"
                            [text]="true"
                            severity="danger"
                            class=""
                            (click)="disconnect()"
                        />
                    </div>
                }

                @if (active && !needsReauth) {
                    <section class="mt-14">
                        <h3 class="tb-h6">
                            {{ "set_int_getting_started_heading" | translate }}
                        </h3>
                        <div class="flex flex-col gap-0 mb-4">
                            <p-button
                                styleClass="p-0 text-left justify-start! w-full!"
                                text
                                [label]="'set_int_usage_step_one' | translate: { integrationName: i.name }"
                                (click)="openInNewTab('/layer/' + layerOneId)"
                            />
                            <!-- routerLink: ['/layer', this.layer1Id.toString()], -->
                            <p-button
                                styleClass="p-0 text-left justify-start! w-full!"
                                text
                                (click)="openInNewTab('/analyze/detail')"
                                [label]="'set_int_usage_step_two' | translate"
                            />
                        </div>
                    </section>

                    <!-- Import
                        <section>
                            <h3 class="mb-4 text-base font-bold">1. Import Data from {{ integration.name }}</h3>

                            <p class="mb-7">
                                Choose which timeBuzzer layers should receive data from
                                {{ integration.name }}.
                            </p>

                            <div class="flex flex-col gap-5">
                                @for (mapping of importMappings; track mapping.id) {
                                    <div class="grid grid-cols-[150px_150px_auto] items-center gap-4 max-md:grid-cols-1 max-md:gap-2">
                                        <label [for]="mapping.id" class="whitespace-nowrap"> “{{ mapping.label }}” - Layer </label>

                                        <p-select
                                            [inputId]="mapping.id"
                                            [options]="layerOptions"
                                            optionLabel="label"
                                            optionValue="value"
                                            placeholder="Select"
                                            styleClass="w-full"
                                        />

                                        <p-button label="Import" [link]="true" severity="secondary" />
                                    </div>
                                }
                            </div>

                            <p class="mt-9 mb-0">
                                Don’t have matching layers yet?
                                <a class="inline-flex items-center gap-1 text-primary cursor-pointer">
                                    Adjust layers in timeBuzzer
                                    <i class="pi pi-external-link text-xs"></i>
                                </a>
                            </p>
                        </section>
                        -->

                    <!-- Export

                            <section class="mt-11">
                                <h3 class="mb-4 text-base font-bold">2. Export Data from timeBuzzer</h3>

                                <a class="inline-flex items-center gap-3 text-primary cursor-pointer">
                                    Go to time entries page
                                    <i class="pi pi-external-link text-xs"></i>
                                </a>
                            </section>
                            -->

                    <!-- Advanced Settings -->
                    <!-- add further advanced settings with || to hasAdvancedSettings -->
                    @let supportsUnitMapping = !!integration().integration?.properties?.supportsUnitMapping;
                    @let hasAdvancedSettings = supportsUnitMapping;
                    @if (hasAdvancedSettings) {
                        <section class="mt-14">
                            <h3 class="mb-6 tb-h6">
                                {{ "set_int_advanced_settings_heading" | translate }}
                            </h3>

                            @if (supportsUnitMapping) {
                                <div class="w-full max-w-4xl">
                                    <app-integration-unit-mapping
                                        [integration]="integration()"
                                        [missingUnits]="missingUnits"
                                        (onUnitsChanged)="onUnitsChanged($event)"
                                    />
                                </div>
                            }
                        </section>
                    }
                }
            </div>
        </p-card>
    </div>

    @if (isApiKeyAuth && (avaiable || needsReauth)) {
        <app-integration-api-key-dialog [integration]="i" [(showAddApiKeyDialog)]="showAddApiKeyDialog" (apiKeyChange)="onApiKeyChange($event)" />
    }
}
